export default __webpack_public_path__ + "9526470852428b4340ed994462821463.woff2";